import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Play, Pause, RotateCcw, Timer } from "lucide-react";
import { elapsedTime, formatStopwatch, readStopwatch, updateStopwatch } from "@/lib/stopwatch";

export default function MatchStopwatch({ matchId }) {
  const key = `coachi-stopwatch-${matchId}`;
  const [timer, setTimer] = useState(() => {
    try { return readStopwatch(localStorage, key); }
    catch { return { elapsed: 0, startedAt: null }; }
  });
  const [now, setNow] = useState(Date.now);
  useEffect(() => {
    try { localStorage.setItem(key, JSON.stringify(timer)); } catch { /* Keep working without storage. */ }
  }, [key, timer]);
  useEffect(() => {
    if (timer.startedAt === null) return;
    const interval = setInterval(() => setNow(Date.now()), 200);
    return () => clearInterval(interval);
  }, [timer.startedAt]);
  const act = (action) => {
    const time = Date.now();
    setNow(time);
    setTimer((previous) => updateStopwatch(previous, action, time));
  };
  return (
    <section className="space-y-3 border-t p-4 text-center" aria-label="Match stopwatch">
      <div className="flex items-center justify-center gap-1 text-xs font-medium text-muted-foreground"><Timer className="h-4 w-4" /> Stopwatch · this device</div>
      <div className="font-mono text-4xl font-bold tabular-nums" role="timer" data-testid="referee-stopwatch">{formatStopwatch(elapsedTime(timer, now))}</div>
      <div className="flex flex-wrap justify-center gap-2">
        <Button variant="outline" onClick={() => act("start")} disabled={timer.startedAt !== null} data-testid="stopwatch-start"><Play className="mr-1 h-4 w-4" /> Start</Button>
        <Button variant="outline" onClick={() => act("stop")} disabled={timer.startedAt === null} data-testid="stopwatch-stop"><Pause className="mr-1 h-4 w-4" /> Stop</Button>
        <Button variant="ghost" onClick={() => act("reset")} data-testid="stopwatch-reset"><RotateCcw className="mr-1 h-4 w-4" /> Reset</Button>
      </div>
      <p className="text-[11px] text-muted-foreground">Stopping or resetting the stopwatch does not finish the match or change scores.</p>
    </section>
  );
}
